'use client';

import { Typography } from '@capsule/consumer-design-system';

import { useTranslations } from 'next-intl';

import { ClearRxLayout } from './ClearRxLayout';

export const HubNotFound = () => {
  const t = useTranslations('hubNotFound');

  return (
    <ClearRxLayout>
      <Typography variant="heading3">{t('message')}</Typography>
    </ClearRxLayout>
  );
};
